import { RfiDocumentOptionDto, RfiDto } from 'src/api/FiretrolApiClient';
import { rfiApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleQueries } from 'src/api/queries/workflowModules/createModuleQueries';
import { queryKeys } from 'src/api/queries/queryKeys';

const queries = createModuleQueries<RfiDto, RfiDocumentOptionDto>({
  label: 'RFI',
  listKey: queryKeys.rfis.list,
  detailKey: queryKeys.rfis.detail,
  documentOptionsKey: queryKeys.rfis.documentOptions,
  list: (jobId, ct) => rfiApiClient.getRfisByJob(jobId, ct),
  detail: (jobId, id, ct) => rfiApiClient.getRfiById(jobId, id, ct),
  documentOptions: (jobId, ct) => rfiApiClient.getDocumentOptions(jobId, ct),
});

/** @registry RFIs for one job; shared by the RFI module and the job summary card. */
export const useRfisList = queries.useList;
export const useRfi = queries.useDetail;
export const useRfiDocumentOptions = queries.useDocumentOptions;
